// /* eslint-disable no-lone-blocks */styled


import './urlParameter.css';

import React, {Component} from "react";
import { Image, ButtonGroup, Dropdown, DropdownButton} from 'react-bootstrap';
//import 'bootstrap/dist/css/bootstrap.min.css';
//import styled from 'styled-components';

import { FiActivity, FiBox, FiCrosshair, FiLayers, FiMoreHorizontal, FiPause, FiPlay, FiSmartphone, FiSun } from "react-icons/fi";

//import '@google/model-viewer';
//import '@google/model-viewer/dist/model-viewer.min.js';
import '@google/model-viewer/dist/model-viewer';

import QrCode from 'qrcode.react';

import windowSize from 'react-window-size';

//import hdr_background from './components/abandoned_factory_canteen_02_1k.hdr'
//import hdr_background from './components/photo_studio_01_1k.hdr'
import hdr_background from './components/sidekix-media-BAVam-y_9Wg-unsplash.jpg'

import xenkia_logo_32x32 from './icon/xenkia32x32.png'



class UrlParameter extends Component{

    state = {

              width                       : '640px', 
              height                      : '480px', 
              backgroundColor             : '#F4F7F9',
              exposurePercentage          : 50,
              play_pauseButtonState       : 'pause',
              full_address                : "",
              usdz_address                : "",
              qrCode_address              : "",
              poster_address              : "",
              friendlyAssetName           : "",
              infoObtainedFromServer      : false,
              matVariantListShow          : 'none',
              animationListShow           : 'none',
              dispAnimPlayPauseButton     : 'none',
              listOfVariants              : [],
              listOfAnimations            : [],
              selectedVariant             : "",

              // Progress Bar.
              loadingProgressBar          : 0,
              loadingProgressBarVisible   : false,

              defaultTarget               : '',
              defaultOrbit                : '',

              modelViewerAutoplay         : "autoplay",

              showMoreControls            : false,
              showViewPresets             : false,
              showBrightnessControl       : false,
              brightnessControlSource     : null,
              qrCardSize                  : 'default',
              selectedCameraView          : '',
              // url Params:
              DisplayName                 : false,
              AREnabled                   : false,
              ShowTagLine                 : false,
              ARPlacement                 : "floor",
              Animate                     : false,
              DefaultExposure             : 50,
              ZoomEnabled                 : false,
              QRCodeEnabled               : false,
              autoRotate                  : true
            };

    // URL.
    currentURL                  = "";

    // url Params:
    uuid                        = "";
    
    testVariants = ["Var1", "Var2"];

    modelViewer;


    // This is the default ModelViewer Exposure.
    buttonOpacity       = 50;

    constructor(props) {
        super(props);

        this.exposureControl          = this.exposureControl.bind(this);
        this.start_pause_animation    = this.start_pause_animation.bind(this);
        this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
        this.brightnessControlRef = React.createRef();
        this.brightnessMoreControlRef = React.createRef();
    }

    


    // Do everything after all the components have been mounted.
    async componentDidMount(){

        document.addEventListener('pointerdown', this.handleDocumentPointerDown);

        const modelViewer = document.querySelector('#model');
        const tapDistance = 2;

        let panning = false;
        let panX, panY;
        let startX, startY;
        let lastX, lastY;
        let metersPerPixel;

        let assetDetails;


        // Store the current URL.
        this.currentURL = window.location.href;

        // Set the Resolution of the model-viewer.
        this.setState({width: this.props.windowWidth.toString()+'px',   height: this.props.windowHeight.toString()+'px'});


        //this.setState({width: window.innerWidth.toString()+'px',   height: window.innerHeight.toString()+'px'});
        //console.log(window.innerWidth, window.innerWidth);     

        // Logic for extracting the parameters. Check the following link to parse URL parameters.
        // Note: https://www.sitepoint.com/get-url-parameters-with-javascript/, https://stackoverflow.com/questions/8486099/how-do-i-parse-a-url-query-parameters-in-javascript
        //"http://localhost:3000/params=1&uuid=65f7132e-0aeb-54b8-9ec0-34f6200332d8&DisplayName=false&AREnabled=true&Animate=true&DefaultExposure=50&ShowTagLine=true"

        // Extract the parameters from the URL.
        {
          const urlParams = new URLSearchParams(window.location.href);

          if(urlParams.has('uuid'))
          {
            this.uuid =  urlParams.get('uuid');

            // Get rid of the '/' at the end if any.
            if (this.uuid.slice(-1) === '/')
            {
              this.uuid = this.uuid.slice(0, -1);
            }

            //console.log(this.uuid);
            //alert(this.uuid);
          }
          if(urlParams.has('DisplayName'))
          {
            this.setState({DisplayName:  (urlParams.get('DisplayName').toLowerCase() === 'true')});

            //console.log(this.DisplayName);
          }
          if(urlParams.has('AREnabled'))
          {
            this.setState({AREnabled:  (urlParams.get('AREnabled').toLowerCase() === 'true')});
            //console.log(this.AREnabled);
          }
          if(urlParams.has('Animate'))
          {
            this.setState({Animate :  (urlParams.get('Animate').toLowerCase() === 'true')});
            //console.log(this.Animate);
          }
          if(urlParams.has('DefaultExposure'))
          {
            this.setState({exposurePercentage:  Number(urlParams.get('DefaultExposure'))});
            //console.log(this.DefaultExposure);
          }
          if(urlParams.has('ShowTagLine'))
          {
            this.setState({ShowTagLine:  (urlParams.get('ShowTagLine').toLowerCase() === 'true')});
            //console.log(this.ShowTagLine);
          }
          if(urlParams.has('ARPlacement'))
          {
            this.setState({ARPlacement:  urlParams.get('ARPlacement').toLowerCase()});
            //console.log(urlParams.get('ARPlacement').toLowerCase());
          }
          if(urlParams.has('ZoomEnabled'))
          {
            this.setState({ZoomEnabled:  (urlParams.get('ZoomEnabled').toLowerCase() === 'true')});
            //console.log(this.ZoomEnabled);
          }
        }

        // Get settings from remote DB.
        {
            const urlParams   =   new URLSearchParams(window.location.href);
            const uuid        =   urlParams.get('uuid');

            if(urlParams.has('uuid'))
            {
              // Get rid of the '/' at the end if any.
              if (uuid.slice(-1) === '/')
              {
                uuid = uuid.slice(0, -1);
              }
            }


            // Get 3D-viewer settings from Remote DB
            var res = await fetch('https://17vpdulb4e.execute-api.us-east-1.amazonaws.com/prod/updatesettings', {
                method: 'POST',
                /* mode: 'no-cors', */
                body: JSON.stringify({
                    request:            "getViewerSettings",
                    asset_uuid:         uuid
                })
            });

            // Get the response from the Backend.
            var response = await res.json();
            
            // If the response is OK, then do the followings.
            if(response.statusCode === 200)
            {
                console.log(response.body.settings);

                if(response.body.settings.displayName === 'true') this.setState({DisplayName: true});
                else this.setState({DisplayName:  false});

                if(response.body.settings.displayTagline === 'true') this.setState({ShowTagLine: true});
                else this.setState({ShowTagLine:  false});

                this.setState({backgroundColor: response.body.settings.bkgrndColor});

                if(response.body.settings.enableDepth === 'true') document.getElementById("model").style.boxShadow = 'inset 0px -400px 400px -400px grey';
                else document.getElementById("model").style.boxShadow = 'none';

                document.querySelector('#model').variantName = response.body.settings.defaultVariant;
                this.setState({selectedVariant:  response.body.settings.defaultVariant});

                this.setState({exposurePercentage: Math.round(response.body.settings.defaultExposure * 10)});

                if(response.body.settings.enableQRCode === 'true') this.setState({QRCodeEnabled: true});
                else this.setState({QRCodeEnabled: false});

                // Enable/Disable AR Zoom.
                if(response.body.settings.enableZoom === 'true') this.setState({ZoomEnabled:  true});
                else this.setState({ZoomEnabled:  false});

                if(response.body.settings.enableAR === 'true') this.setState({AREnabled:  true});
                else this.setState({AREnabled:  false});
            }
          
        }



        /* const params    = test.split('?').slice(1);
        console.log(params); 
        console.log(params.toString()); */

        

        // Get the asset details. This is temporary.
        //assetDetails = await GetAssetDetails(this.props.location.pathname.split('/')[1]);
        //console.log(this.props.location.pathname.split('/')[1]);

        /* 
          Get Asset details.
        */
        // Incease the upload counter by 1 in the remote database..
        var res = await fetch("https://q5rygp0k2h.execute-api.us-east-1.amazonaws.com/prod/getdetails", {
          method: 'POST',
          //mode: 'no-cors',
          body: JSON.stringify({
              "request" :          "readDetails",
              //"uuid"    :          this.props.location.pathname.split('/')[1]
              "uuid"    :          this.uuid
          })
        });
        
        // Get the response from the Backend.
        var response = await res.json();
        
        //console.log(response);

        // Only update the Upload counter if the remote Upload counter was successfully incremented.
        if(response.statusCode === 200)
        {
              //console.log(this.Animate);
              //console.log(response.body.data.Item);


/*               // Based on the URL parameter, turn on/off animation.
              if(this.Animate === true) this.setState({modelViewerAutoplay : "autoplay "});
              else this.setState({modelViewerAutoplay : ""}); */


              // Prevent Right Mouse Button Click.
              document.addEventListener('contextmenu', (e) => {
                  e.preventDefault();
                });
                

              // Get the Friendly Asset Name.
              this.setState({friendlyAssetName: response.body.data.Item.friendlyAssetName});

              // Mark that the model specific information has been obtained from the server. This is needed to stop displaying the GREEN circle.
              this.setState({
                infoObtainedFromServer: true,
                loadingProgressBar: 0,
                loadingProgressBarVisible: true,
              });


              // Increase the View/Download count by 1.
              IncreaseViewCount(response.body.data.Item.email);

              // Increase the Assets View Count based on UUID.
              //IncreaseAssetViewCount(this.props.location.pathname.split('/')[1]);
              IncreaseAssetViewCount(this.uuid);
              
              // Download progress bar.
              // Note: https://www.gitmemory.com/issue/google/model-viewer/2302/824724336
              {
                modelViewer.addEventListener('progress', (event) => {
                  const progress = Math.min(100, Math.max(0, event.detail.totalProgress * 100));
                  this.setState({
                    loadingProgressBar: progress,
                    loadingProgressBarVisible: !modelViewer.loaded,
                  });
                });
              }

              // Material Variants.
              const modelViewerVariants     = document.querySelector("model-viewer#model");
              const selectVariants          = document.querySelector('#variant');
              const selectAnimations        = document.querySelector('#animations');
              const reactDropdown          = document.querySelector('#variant-list');

              // Note: https://github.com/google/model-viewer/issues/1573
              modelViewer.addEventListener('load', () => {

                // Record the default Target and default Orbit values, to be used to re-center the camera when the re-center button is pressed.
                {   const cameraOrbit   = modelViewer.getCameraOrbit();
                    const cameraTarget  = modelViewer.getCameraTarget();
                    this.setState({defaultTarget: cameraTarget,   defaultOrbit: cameraOrbit});

                    console.log(cameraOrbit, cameraTarget);
                }

                this.setState({
                  play_pauseButtonState: modelViewer.paused ? 'play' : 'pause',
                  loadingProgressBar: 100,
                  loadingProgressBarVisible: false,
                });

                // Load default exposure control.
                {
                    modelViewer.exposure = this.state.exposurePercentage / 25;
                    //console.log(modelViewer.exposure, this.state.exposurePercentage);
                }

                // MATERIAL VARIANTS.
                {
                    const names = modelViewer.availableVariants;
                    this.setState({listOfVariants: modelViewer.availableVariants});
                    //console.log(names, this.testVariants);

                    // The 'Variant' list should be shown when there are more than 1 material for the 3d model. 
                    if (names.length > 1) this.setState({matVariantListShow: 'block'});
                    else this.setState({matVariantListShow: 'none'});

                    // // Add the names of Material Variants to the Dropodown menu.
                    // for (const name of names) {
                    //   const matVariantOptions = document.createElement('option');

                    //   matVariantOptions.value = name;
                    //   matVariantOptions.textContent = name;
                    //   selectVariants.appendChild(matVariantOptions);

                    //   //reactDropdown.appendChild(matVariantOptions);
                    // }
                }

                // LIST OF ANIMATIONS.
                {
                    const animationList = modelViewer.availableAnimations;
                    this.setState({listOfAnimations: modelViewer.availableAnimations})
                    //console.log(animationList);

                    // Dispaly the Animation Play/Pause button only if the loaded 3d model at least has 1 animation in it.
                    if (animationList.length > 0) 
                    {
                      this.setState({dispAnimPlayPauseButton: 'block'});
                    }
                    else 
                    {
                      this.setState({dispAnimPlayPauseButton: 'none'});
                    }

                    // The 'Animation' list should be shown when there are more than 1 Animation to choose from for the 3d model.
                    if (animationList.length > 1) 
                    {
                      this.setState({animationListShow: 'block'});
                    }
                    else this.setState({animationListShow: 'none'});

                    // // Add the names of Animations to the Dropodown menu.
                    // for (const name of animationList) {
                    //   const animationOptions = document.createElement('option');

                    //   animationOptions.value = name;
                    //   animationOptions.textContent = name;
                    //   selectAnimations.appendChild(animationOptions);
                    // }
                }
              });

              // If anyone in the Model Viewer has been clicked, then do the followings.
              modelViewer.addEventListener("click", (event) => {
                if (event.target === modelViewer) {
                  this.setState({showMoreControls: false, showViewPresets: false, showBrightnessControl: false, brightnessControlSource: null});
                }
              });

              // // Select the Material Variants based on the users preference.
              // selectVariants.addEventListener('input', (event) => {
              //   modelViewerVariants.variantName = event.target.value;
              // });

              // // Select the Animation to play, based on the users preference.
              // selectAnimations.addEventListener('input', (event) => {
              //   modelViewerVariants.animationName = event.target.value;
              // });


              // // ReactJs drop-down menu click event test.
              // reactDropdown.addEventListener('click', (event) => {
              //   event.target.addEventListener('click', (event) => {
              //     console.log(event.target.value);
              //   });
              // });

              // Panning related functions.
              const startPan = () => {
                  const orbit = modelViewer.getCameraOrbit();
                  const {theta, phi, radius} = orbit;
                  const psi = theta - modelViewer.turntableRotation;
                  metersPerPixel = 0.75 * radius / modelViewer.getBoundingClientRect().height;
                  panX = [-Math.cos(psi), 0, Math.sin(psi)];
                  panY = [
                    -Math.cos(phi) * Math.sin(psi),
                    Math.sin(phi),
                    -Math.cos(phi) * Math.cos(psi)
                  ];
                  modelViewer.interactionPrompt = 'none';
        
                  //console.log("start-pan");
                };
              
                const movePan = (thisX, thisY) => {
                  const dx = (thisX - lastX) * metersPerPixel;
                  const dy = (thisY - lastY) * metersPerPixel;
                  lastX = thisX;
                  lastY = thisY;
              
                  const target = modelViewer.getCameraTarget();
                  target.x += dx * panX[0] + dy * panY[0];
                  target.y += dx * panX[1] + dy * panY[1];
                  target.z += dx * panX[2] + dy * panY[2];
                  modelViewer.cameraTarget = `${target.x}m ${target.y}m ${target.z}m`;
              
                  // This pauses turntable rotation
                  modelViewer.dispatchEvent(new CustomEvent(
                        'camera-change', {detail: {source: 'user-interaction'}}));
        
                  //console.log("move-pan");
                };

              // Panning related Evenet Listeners.
              modelViewer.addEventListener('mousedown', (event) => {
                  startX = event.clientX;
                  startY = event.clientY;
                  panning = event.button === 2 || event.ctrlKey || event.metaKey ||
                      event.shiftKey;
                  if (!panning)
                    return;
              
                  lastX = startX;
                  lastY = startY;
                  startPan();
                  event.stopPropagation();
        
                  //console.log("mouse-down");
                }, true);
              
                modelViewer.addEventListener('touchstart', (event) => {
                  startX = event.touches[0].clientX;
                  startY = event.touches[0].clientY;
                  panning = event.touches.length === 2;
                  if (!panning)
                    return;
              
                  const {touches} = event;
                  lastX = 0.5 * (touches[0].clientX + touches[1].clientX);
                  lastY = 0.5 * (touches[0].clientY + touches[1].clientY);
                  startPan();
                }, true);
              
                modelViewer.addEventListener('mousemove', (event) => {
                  if (!panning)
                    return;
              
                  movePan(event.clientX, event.clientY);
                  event.stopPropagation();
                }, true);
              
                modelViewer.addEventListener('touchmove', (event) => {
                  if (!panning || event.touches.length !== 2)
                    return;
              
                  const {touches} = event;
                  const thisX = 0.5 * (touches[0].clientX + touches[1].clientX);
                  const thisY = 0.5 * (touches[0].clientY + touches[1].clientY);
                  movePan(thisX, thisY);
                }, true);

                modelViewer.addEventListener('mouseup', (event) => {
                  panning = 0;
                }, true);

                // Set the model source only after the progress and load listeners are ready.
                this.setState({
                  full_address: response.body.data.Item.S3Url + response.body.data.Item.fileName + ".glb",
                  usdz_address: response.body.data.Item.S3Url + response.body.data.Item.fileName + ".usdz",
                  qrCode_address: response.body.data.Item.S3Url + "qr/qr_" + response.body.data.Item.fileName + ".png",
                  poster_address: response.body.data.Item.S3Url + "POSTER_" + response.body.data.Item.fileName + ".png",
                });

        }
        else
        { 
            // Mark that the model specific information could not be loaded.
            this.setState({infoObtainedFromServer: false});

            console.log("Error: ", response.statusCode);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('pointerdown', this.handleDocumentPointerDown);
    }

    componentDidUpdate(previousProps) {
        if (
          previousProps.windowWidth === this.props.windowWidth &&
          previousProps.windowHeight === this.props.windowHeight
        ) return;

        this.handleWindowResize();
    }

    handleWindowResize = () => {
        const windowWidth = Number(this.props.windowWidth) || window.innerWidth;
        const viewportWidth = window.innerWidth || windowWidth;
        const viewportHeight = window.innerHeight || Number(this.props.windowHeight);
        const width = `${viewportWidth}px`;
        const height = `${viewportHeight}px`;

        this.setState((state) => {
          if (state.width === width && state.height === height) return null;

          return {
            width,
            height,
          };
        });
    }

    // This will Re-center the model.
    recenterModel()
    {
        const modelViewer = document.querySelector("#model");

        //modelViewer.cameraTarget= `${0}m ${0.5}m ${0}m`;
        //modelViewer.cameraTarget    = `auto auto auto`;
        if (!modelViewer || !this.state.defaultTarget || !this.state.defaultOrbit) return;

        modelViewer.cameraTarget    = this.state.defaultTarget;
        modelViewer.cameraOrbit     = this.state.defaultOrbit;

        
        //modelViewer.cameraOrbit     = "30deg 55deg" + this.state.defaultOrbit.radius;     // Perspective view.
        //modelViewer.cameraOrbit     = "0deg 0deg" + this.state.defaultOrbit.radius;       // Top view.
        //modelViewer.cameraOrbit     = "90deg 90deg" + this.state.defaultOrbit.radius;     // Side view.
        //modelViewer.cameraOrbit     = "0deg 1800deg" + this.state.defaultOrbit.radius;    // Bottom view.

        //modelViewer.fieldOfView= 
        //modelViewer.position = ;

        //console.log("recenter");
    }


    // We will change the exposure of the Model-Viewer here.
    exposureControl(sliderChangeEvent)
    {
        let modelViewer = document.querySelector('#model');

/*         // Cycle exposure between 25% and 100% based on the users preference.
        if(this.state.exposurePercentage < 100) this.setState({exposurePercentage: (this.state.exposurePercentage+25)});
        else this.setState({exposurePercentage: 25});

        // Update the model-viewer exposure value [1-4].
        modelViewer.exposure = this.state.exposurePercentage / 25;

        console.log(modelViewer.exposure, this.state.exposurePercentage); */

        // Cycle exposure between 1 and 4 based on the users preference.
        // if(modelViewer.exposure < 4)
        // {
        //     modelViewer.exposure++;
        // }
        // else
        // {
        //     modelViewer.exposure = 1;
        // }

        modelViewer.exposure            = Number(sliderChangeEvent) / 25;

        // This will help display the percentage of exposure.
        // Note: https://stackoverflow.com/questions/32317154/react-uncaught-typeerror-cannot-read-property-setstate-of-undefined.
        this.setState({exposurePercentage: Math.round(modelViewer.exposure * 25)});

        //console.log(modelViewer.exposure);
    }


    // This function will Start/Pause the Animation.
    start_pause_animation()
    {
        let modelViewer             = document.querySelector('#model');

        //console.log(modelViewer.childNodes);

        if (modelViewer.paused) {
            modelViewer.play();
            this.setState({play_pauseButtonState: 'pause'});
        } else {
            modelViewer.pause();
            this.setState({play_pauseButtonState: 'play'});
        }
        
    }


    toggleMoreControls() {
        this.setState((state) => ({
          showMoreControls: !state.showMoreControls,
          showViewPresets: false,
          showBrightnessControl: false,
          brightnessControlSource: null,
        }));
    }

    toggleViewPresets() {
        this.setState((state) => ({
          showViewPresets: !state.showViewPresets,
          showMoreControls: false,
          showBrightnessControl: false,
          brightnessControlSource: null,
        }));
    }

    toggleBrightnessControl(source = 'rail') {
        this.setState((state) => ({
          showBrightnessControl: !(state.showBrightnessControl && state.brightnessControlSource === source),
          brightnessControlSource: state.showBrightnessControl && state.brightnessControlSource === source ? null : source,
          showViewPresets: false,
          showMoreControls: source === 'more' ? state.showMoreControls : false,
        }));
    }

    handleDocumentPointerDown(event) {
        const clickedRailBrightness = this.brightnessControlRef.current?.contains(event.target);
        const moreBrightnessButton = this.brightnessMoreControlRef.current?.querySelector('[aria-controls="viewer-brightness-more-panel"]');
        const moreBrightnessPanel = this.brightnessMoreControlRef.current?.querySelector('#viewer-brightness-more-panel');
        const clickedMoreBrightness = moreBrightnessButton?.contains(event.target) || moreBrightnessPanel?.contains(event.target);
        if (this.state.showBrightnessControl && !clickedRailBrightness && !clickedMoreBrightness) {
          this.setState({showBrightnessControl: false, brightnessControlSource: null});
        }
    }

    renderBrightnessSlider(id) {
        return (
          <>
            <div className="brightness-heading">
              <label htmlFor={id}><FiSun aria-hidden="true" />Brightness</label>
              <output htmlFor={id}>{this.state.exposurePercentage}%</output>
            </div>
            <input
              id={id}
              className="brightness-range"
              type="range"
              min="0"
              max="100"
              step="1"
              value={this.state.exposurePercentage}
              aria-label="Brightness"
              disabled={!this.state.showBrightnessControl}
              onChange={(event) => this.exposureControl(event.target.value)}
            />
            <div className="brightness-range-labels" aria-hidden="true">
              <span>Dim</span>
              <span>Bright</span>
            </div>
          </>
        );
    }

    toggleQRCodeSize() {
        this.setState((state) => ({
          qrCardSize: state.qrCardSize === 'expanded' ? 'compact' : 'expanded',
        }));
    }

    toggleAutoRotation() {
        this.setState((state) => ({autoRotate: !state.autoRotate}));
    }

    setCameraView(view) {
        const modelViewer = document.querySelector('#model');
        const radius = this.state.defaultOrbit?.radius;

        if (!modelViewer || !radius) return;

        if (view === 'isometric') modelViewer.resetTurntableRotation(-0.610865238);

        const orbit = {
          isometric: `-35deg 65deg ${radius}m`,
          top: `0deg 0deg ${radius}m`,
          bottom: `0deg 180deg ${radius}m`,
          side: `90deg 90deg ${radius}m`,
        }[view];

        modelViewer.cameraOrbit = orbit;
        this.setState({selectedCameraView: view, showViewPresets: false, showMoreControls: false});
    }



    render()
    {   
          const modelViewer = document.querySelector('#model');
          const loadingProgress = Math.round(this.state.loadingProgressBar);
          const isLoadingModel = !this.state.infoObtainedFromServer || this.state.loadingProgressBarVisible;

          return(
                <model-viewer
                    id                      = 'model'
                    environment-image       = {hdr_background}
                    shadow-intensity        = "1"
                    shadow-softness         = "1"
                    style                   = {{width: this.state.width, height: this.state.height, backgroundColor: this.state.backgroundColor}}
                    src                     = {this.state.full_address}
                    ios-src                 = {this.state.usdz_address}
                    // poster                  = {this.state.poster_address}
                    alt                     = "3D model"
                    //auto-rotate
                    camera-orbit            = "auto 65deg 100%"
                    field-of-view           = "30deg"
                    min-field-of-view       = "30deg"
                    max-field-of-view       = "120deg"
                    max-camera-orbit        = 'Infinity 180deg auto'
                    min-camera-orbit        = '-Infinity 0deg auto'
                    camera-controls
                    
                    // auto-rotate can now be enabled/disabled.
                    // Src: https://stackoverflow.com/questions/7122609/how-do-i-reference-a-javascript-object-property-with-a-hyphen-in-it
                    {...(this.state.autoRotate ? {['auto-rotate']: true} : {})}

                    // This part Enables/Disables the AR functionality.
                    {...(this.state.AREnabled ? {ar: true} : {})}
                    
                    // Values between [1-4] is accepted.
                    exposure                = {this.state.exposurePercentage / 25}
                    autoplay                
                    
                    ar-placement            = {this.state.ARPlacement}
                    //ar-placement            = "wall"
                    ar-scale                = {this.state.ZoomEnabled ? "auto" : "fixed"}
                    ar-modes                = "webxr scene-viewer quick-look"
                >

                    {(this.state.DisplayName || this.state.matVariantListShow === 'block') &&
                      <div className="viewer-title-group">
                        {this.state.DisplayName &&
                          <h3 className="asset-name">
                            <b>{this.state.friendlyAssetName}</b>
                          </h3>
                        }
                        {this.state.matVariantListShow === 'block' &&
                          <div className="viewer-variant-badge">
                            <span className="viewer-variant-label">Variant</span>
                            <strong>{this.state.selectedVariant}</strong>
                          </div>
                        }
                      </div>
                    }

                    {this.state.ShowTagLine
                      ? <div className="viewer-tagline">
                          <Image src={xenkia_logo_32x32} alt="" />
                          <span>Powered by</span>
                          <a href="https://www.xenkia.com/" target="_blank" rel="noreferrer">Xenkia, Inc.</a>
                          <span>©{new Date().getFullYear()}</span>
                        </div>
                      : <> </>
                    }


                    {this.state.AREnabled && (window.innerWidth < 1024 || !this.state.QRCodeEnabled) &&
                      <button className="viewer-ar-cta" slot="ar-button" type="button">
                        <FiSmartphone aria-hidden="true" />
                        <span>View in your space</span>
                      </button>
                    }

                    <div className={`viewer-view-menu${this.state.showViewPresets ? ' is-open' : ''}`}>
                      <button
                        type="button"
                        className="viewer-view-toggle"
                        aria-label="Views"
                        aria-expanded={this.state.showViewPresets}
                        aria-controls="viewer-view-presets"
                        onClick={() => this.toggleViewPresets()}
                      >
                        <FiBox aria-hidden="true" />
                      </button>
                      <div id="viewer-view-presets" className="view-presets" role="group" aria-label="Camera views" hidden={!this.state.showViewPresets}>
                        {[
                          ['isometric', 'Isometric'],
                          ['top', 'Top'],
                          ['bottom', 'Bottom'],
                          ['side', 'Side'],
                        ].map(([view, label]) => (
                          <button
                            key={view}
                            type="button"
                            className={`view-preset${this.state.selectedCameraView === view ? ' is-selected' : ''}`}
                            aria-pressed={this.state.selectedCameraView === view}
                            onClick={() => this.setCameraView(view)}
                          >
                            {label}
                          </button>
                        ))}
                      </div>

                      <div className="viewer-action-rail" role="toolbar" aria-label="Model controls">
                        <span className="viewer-action-divider" aria-hidden="true" />

                        <div
                          ref={this.brightnessControlRef}
                          className={`viewer-brightness-anchor${this.state.showBrightnessControl && this.state.brightnessControlSource === 'rail' ? ' is-open' : ''}`}
                          onKeyDown={(event) => {
                            if (event.key === 'Escape' && this.state.showBrightnessControl) {
                              this.setState({showBrightnessControl: false, brightnessControlSource: null});
                              event.currentTarget.querySelector('button')?.focus();
                            }
                          }}
                        >
                          <button
                            type="button"
                            className="viewer-side-control"
                            aria-label="Brightness"
                            aria-expanded={this.state.showBrightnessControl && this.state.brightnessControlSource === 'rail'}
                            aria-controls="viewer-brightness-rail-popover"
                            data-tooltip="Brightness"
                            onClick={() => this.toggleBrightnessControl('rail')}
                          >
                            <FiSun aria-hidden="true" />
                          </button>
                          <div
                            id="viewer-brightness-rail-popover"
                            className="viewer-brightness-popover"
                            aria-hidden={!(this.state.showBrightnessControl && this.state.brightnessControlSource === 'rail')}
                          >
                            {this.state.brightnessControlSource === 'rail' && this.renderBrightnessSlider('viewer-brightness-rail')}
                          </div>
                        </div>

                        <button
                          type="button"
                          className="viewer-side-control"
                          aria-label="Reset view"
                          data-tooltip="Reset view"
                          disabled={!this.state.defaultOrbit}
                          onClick={() => this.recenterModel()}
                        >
                          <FiCrosshair aria-hidden="true" />
                        </button>

                        <button
                          type="button"
                          className="viewer-side-control"
                          aria-label={this.state.autoRotate ? 'Stop rotation' : 'Start rotation'}
                          aria-pressed={this.state.autoRotate}
                          data-tooltip={this.state.autoRotate ? 'Stop rotation' : 'Start rotation'}
                          onClick={() => this.toggleAutoRotation()}
                        >
                          {this.state.autoRotate ? <FiPause aria-hidden="true" /> : <FiPlay aria-hidden="true" />}
                        </button>
                      </div>
                    </div>



                    {/* <button slot="ar-button" id="ar-button">
                        View in your space
                    </button> */}

                    {isLoadingModel &&
                      <div className="viewer-loading" role="status" aria-live="polite">
                        <div className="viewer-loading-heading">
                          <span className="viewer-loading-spinner" aria-hidden="true" />
                          <div className="viewer-loading-copy">
                            <strong>Loading your 3D model</strong>
                            <span>{this.state.infoObtainedFromServer ? 'Preparing the scene' : 'Fetching model details'}</span>
                          </div>
                          {this.state.infoObtainedFromServer && <output>{loadingProgress}%</output>}
                        </div>
                        <div
                          className="viewer-loading-track"
                          role="progressbar"
                          aria-label="3D model loading progress"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          aria-valuenow={this.state.infoObtainedFromServer ? loadingProgress : undefined}
                          aria-valuetext={this.state.infoObtainedFromServer ? `${loadingProgress}%` : 'Fetching model details'}
                        >
                          <span
                            className={`viewer-loading-fill${this.state.infoObtainedFromServer ? '' : ' is-indeterminate'}`}
                            style={this.state.infoObtainedFromServer ? {width: `${loadingProgress}%`} : undefined}
                          />
                        </div>
                      </div>
                    }

                    <div className="viewer-control-dock">
                      <section
                        className="viewer-more-panel"
                        id="viewer-more-panel"
                        aria-label="More controls"
                        hidden={!this.state.showMoreControls}
                      >
                        <div className="viewer-more-heading">More controls</div>
                        <div
                          ref={this.brightnessMoreControlRef}
                          className="viewer-more-control-stack"
                        >
                          <div className="viewer-secondary-toolbar viewer-secondary-toolbar--primary" role="group" aria-label="Viewer controls">
                            <button
                              type="button"
                              className="viewer-control"
                              aria-label="Brightness"
                              aria-expanded={this.state.showBrightnessControl && this.state.brightnessControlSource === 'more'}
                              aria-controls="viewer-brightness-more-panel"
                              onClick={() => this.toggleBrightnessControl('more')}
                            >
                              <FiSun aria-hidden="true" /><span>Brightness</span>
                            </button>

                            <button
                              type="button"
                              className="viewer-control"
                              aria-label="Reset view"
                              disabled={!this.state.defaultOrbit}
                              onClick={() => this.recenterModel()}
                            >
                              <FiCrosshair aria-hidden="true" /><span>Reset</span>
                            </button>

                            <button
                              type="button"
                              className="viewer-control"
                              aria-label={this.state.autoRotate ? 'Stop rotation' : 'Start rotation'}
                              aria-pressed={this.state.autoRotate}
                              onClick={() => this.toggleAutoRotation()}
                            >
                              {this.state.autoRotate ? <FiPause aria-hidden="true" /> : <FiPlay aria-hidden="true" />}
                              <span>{this.state.autoRotate ? 'Stop rotation' : 'Start rotation'}</span>
                            </button>
                          </div>
                          <div
                            id="viewer-brightness-more-panel"
                            className={`viewer-more-brightness${this.state.showBrightnessControl && this.state.brightnessControlSource === 'more' ? ' is-open' : ''}`}
                            aria-hidden={!(this.state.showBrightnessControl && this.state.brightnessControlSource === 'more')}
                          >
                            {this.state.brightnessControlSource === 'more' && this.renderBrightnessSlider('viewer-brightness-more')}
                          </div>
                        </div>

                        {(this.state.animationListShow === 'block' || this.state.dispAnimPlayPauseButton === 'block') &&
                          <div className="viewer-secondary-toolbar" role="group" aria-label="Animation controls">
                            {this.state.animationListShow === 'block' &&
                              <DropdownButton
                                as={ButtonGroup}
                                id="animation-list"
                                drop="up"
                                className="viewer-dropdown"
                                title={<><FiActivity aria-hidden="true" /><span>Motion</span></>}
                              >
                                {this.state.listOfAnimations.map((animationName) => (
                                  <Dropdown.Item
                                    key={animationName}
                                    onClick={() => { modelViewer.animationName = animationName; }}
                                  >
                                    {animationName}
                                  </Dropdown.Item>
                                ))}
                              </DropdownButton>
                            }

                            {this.state.dispAnimPlayPauseButton === 'block' &&
                              <button
                                type="button"
                                className="viewer-control"
                                aria-label={this.state.play_pauseButtonState === 'play' ? 'Play animation' : 'Pause animation'}
                                onClick={() => this.start_pause_animation()}
                              >
                                {this.state.play_pauseButtonState === 'play'
                                  ? <FiPlay aria-hidden="true" />
                                  : <FiPause aria-hidden="true" />}
                                <span>{this.state.play_pauseButtonState === 'play' ? 'Play' : 'Pause'}</span>
                              </button>
                            }
                          </div>
                        }
                      </section>

                      <div className="viewer-toolbar" role="group" aria-label="Primary viewer controls">
                        {this.state.matVariantListShow === 'block' &&
                          <Dropdown
                            id="variant-list"
                            drop="up"
                            align="start"
                            autoClose={true}
                            className="viewer-dropdown"
                          >
                            <Dropdown.Toggle variant="primary">
                              <FiLayers aria-hidden="true" /><span>Variants</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {this.state.listOfVariants.map((variant) => (
                                <Dropdown.Item
                                  key={variant}
                                  active={this.state.selectedVariant === variant}
                                  onClick={() => {
                                    modelViewer.variantName = variant;
                                    this.setState({selectedVariant: variant, showMoreControls: false});
                                  }}
                                >
                                  {variant}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        }

                        <button
                          type="button"
                          className="viewer-control"
                          aria-label={this.state.showMoreControls ? 'Hide more controls' : 'Show more controls'}
                          aria-expanded={this.state.showMoreControls}
                          aria-controls="viewer-more-panel"
                          onClick={() => this.toggleMoreControls()}
                        >
                          <FiMoreHorizontal aria-hidden="true" />
                          <span>More</span>
                        </button>
                      </div>
                    </div>


                    {/* {this.state.matVariantListShow
                      ? <select id="variant" style={{left: '50%', top: '3%', position: 'absolute'}}> </select>
                      : <> </>
                    } */}

                    {/* If the Window Width is greater then 1024 pixels, only then display the QR code. */}
                    {(window.innerWidth >= 1024) && this.state.QRCodeEnabled
                      ? <section
                          className={`qr-card qr-card--${this.state.qrCardSize}`}
                          role="button"
                          tabIndex={0}
                          aria-label={this.state.qrCardSize === 'expanded' ? 'Shrink QR code' : 'Enlarge QR code'}
                          aria-expanded={this.state.qrCardSize === 'expanded'}
                          onClick={() => this.toggleQRCodeSize()}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                              event.preventDefault();
                              this.toggleQRCodeSize();
                            }
                          }}
                        >
                          <div className="qr-card-copy">
                            <p className="qr-card-title">Open on your phone</p>
                            <p className="qr-card-instruction">Scan to continue in AR</p>
                          </div>
                          <div className="qr-code-surface">
                            <QrCode
                              value={window.location.href}
                              size={144}
                              id="qrCode"
                              includeMargin={true}
                              level="Q"
                              renderAs="svg"
                              bgColor="transparent"
                              fgColor="#1e3550"
                            />
                          </div>
                          <p className="qr-card-hint">Use your phone camera app</p>
                        </section>
                      : <> </>
                    }

                </model-viewer>
          );
    }
};


/**
 * 3d Viewer Function.
 */
 async function IncreaseViewCount(email){ 
 
   // Increase the view count.
   {
       // Incease the upload counter by 1 in the remote database..
       var res = await fetch("https://oidnlpynvl.execute-api.us-east-1.amazonaws.com/prod/increaseviewcount", {
         method: 'POST',
         //mode: 'no-cors',
         body: JSON.stringify({
             "email":                email,
             "field_to_update":      "download_counter",
             "value":                1,
             "inc_dec_reset":        "inc"
         })
       });
 
       // Get the response from the Backend.
       var response = await res.json();
 
       // Only update the Upload counter if the remote Upload counter was successfully incremented.
       /* if(response.statusCode === 201)
       {
           console.log("Status Code: 201.");
       }
       else console.log(response); */
   }
 
 }


 /**
 * Increase Asset View Count based on UUID.
 */
  async function IncreaseAssetViewCount(uuid){
  
    // Increase the Assets Local View Count.
    {
        // Incease the upload counter by 1 in the remote database..
        var res = await fetch("https://q5rygp0k2h.execute-api.us-east-1.amazonaws.com/prod/getdetails", {
          method: 'POST',
          //mode: 'no-cors',
          body: JSON.stringify({
              "request" :          "increaseAssetViewCount",
              "uuid"    :          uuid
          })
        });
  
        // Get the response from the Backend.
        var response = await res.json();
  
        // Only update the Upload counter if the remote Upload counter was successfully incremented.
        if(response.statusCode === 201)
        {
            //console.log("Response Code: 201, View Count successfully increased!", response);
            return response;
        }
    }
  
  }

 /**
 * Get Asset Details based on UUID.
 */
  async function GetAssetDetails(uuid){
  
    // Get Asset details.
    {
        // Incease the upload counter by 1 in the remote database..
        var res = await fetch("https://q5rygp0k2h.execute-api.us-east-1.amazonaws.com/prod/getdetails", {
          method: 'POST',
          //mode: 'no-cors',
          body: JSON.stringify({
              "request" :          "readDetails",
              "uuid"    :          uuid
          })
        });
        
        // Get the response from the Backend.
        var response = await res.json();
  
        // Only update the Upload counter if the remote Upload counter was successfully incremented.
        if(response.statusCode === 200)
        {
            console.log("Response Code: 200, Asset details successfuly read!", response.body.data.Item);
            return response;
        }
    }
  
  }

export default windowSize(UrlParameter);
//export default UrlParameter;
